import type { CourseDetailsDisplay, MapCourseDetailsOptions } from '../entities/course-details.entity'
import type { ICourseRepository } from '../repositories/course.repository'
import {
  courseDetailsFakeLearningObjectives,
  courseDetailsFakeAuthor,
} from '../providers/course-details.provider'
import { mapToCourseDetailsDisplay } from '@/infrastructure/mappers/course-details.mapper'

const DEFAULT_SECTION_TITLE_KEY = 'courseDetails.curriculum.title'

/**
 * Сервис деталей курса: один запрос к бэку (course + lessons), один маппер внутри.
 */
export class CourseDetailsService {
  constructor(private readonly courseRepository: ICourseRepository) {}

  async getCourseDetailsBySlug(slug: string, options?: MapCourseDetailsOptions): Promise<CourseDetailsDisplay> {
    if (!slug) throw new Error('Course slug is required')
    const raw = await this.courseRepository.findDetailsBySlug(slug)
    const opts = options ?? {
      defaultSectionTitle: DEFAULT_SECTION_TITLE_KEY,
      defaultLearningObjectives: courseDetailsFakeLearningObjectives,
      defaultAuthor: courseDetailsFakeAuthor,
    }
    return mapToCourseDetailsDisplay(raw, opts)
  }
}
